/**
 * V2 Skeleton — shimmer placeholder from design_reference (`.skel`).
 * Uses the `v2-shimmer` keyframe defined in v2-tokens.css.
 */

import type { CSSProperties } from 'react';
import { cn } from '../../../lib/utils';

/** Props for the V2 Skeleton. */
export interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
}

/** V2 shimmer skeleton block. */
export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <div
      className={cn(
        'rounded',
        'bg-[linear-gradient(90deg,var(--bg-3)_25%,var(--bg-4)_37%,var(--bg-3)_63%)] bg-[length:400%_100%]',
        'animate-[v2-shimmer_1.4s_infinite]',
        className,
      )}
      style={style}
      aria-hidden="true"
    />
  );
}
